import React from "react";
import { Switch } from "@progress/kendo-react-inputs";
import "./inputSwitchHLPure.css";

const InputSwitchHLPure = (props) => {
    let {
        labelInput,
        customClass,
        required
    } = props

    return (
        <div className={customClass}>
            {
                labelInput ? (
                    <>
                        <label className="inputSwitchHLPure-label" name={`labelSwitch${labelInput}`}>
                            {labelInput}{required && "*"}
                        </label>
                        <Switch
                            {...props}
                        />
                    </>
                ) : (
                    <Switch
                        {...props}
                    />
                )
            }
        </div>
    )
}

export { InputSwitchHLPure as default }